import { RootState } from '../../../../../store/root-reducer';

export const isPaddleProvider = (getState: () => unknown): boolean => {
  const state = getState() as RootState;
  return state.home?.paymentProvider === 'paddle';
};

export async function resolvePaymentApi<T>(
  getState: () => unknown,
  paddleFn: () => Promise<any>,
  stripeFn: () => Promise<T>,
): Promise<T> {
  if (isPaddleProvider(getState)) {
    return await paddleFn();
  }
  return stripeFn();
}
